
/**
 * 工作流-MCP节点
 * zxw
 * 创建时间 2026-04-09
 */

import CNF from '../../incs/Config';
import {
    winHeight,
    AddRequestHeaders,
} from '../../incs/FunHelper';
import { useState, useEffect } from 'react';
import $ from 'jquery';
import {
    ConfigProvider,
    message,
    Modal,
    Avatar,
    Space,
    Divider,
    Input,
    Select,
    Button,
    Popover,
    Flex,
    Typography,
    Row,
    Col,
    InputNumber,
    Tag,
} from 'antd';
import {
    CheckOutlined,
    EditOutlined,
    RightOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

const MCPNodeEntity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(false);
    const [isEditTitle, setIsEditTitle] = useState(false);  // 标题是否编辑
    const [currentTitle, setCurrentTitle] = useState(props.node.data?.title);   // 当前标题

    const [mcpToolList, setMCPToolList] = useState([]);
    const [toolName, setToolName] = useState('');       // 工具名称
    const [description, setDescription] = useState(''); // 工具描述
    const [parameters, setParameters] = useState({});   // 工具参数
    const [currentParameterKey, setCurrentParameterKey] = useState(''); // 当前参数key

    // 转换函数：将数组转换为 antd Select 的分组 options
    function transformToGroupOptions(arr) {
        const moduleMap = {};

        arr.forEach(item => {
            // 解析 title，假设格式为 "模块名-功能描述"
            const parts = item.title.split('-');
            if (parts.length < 2) return; // 容错：不符合格式的项跳过

            const moduleName = parts[0].trim();
            const funcLabel = parts.slice(1).join('-').trim(); // 防止功能描述中也包含'-'

            // 如果该模块还不存在于 map 中，先创建模块对象
            if (!moduleMap[moduleName]) {
                moduleMap[moduleName] = {
                    label: moduleName,
                    name: moduleName,
                    options: []
                };
            }

            // 添加版本对象
            moduleMap[moduleName].options.push({
                label: funcLabel,
                value: item.name
            });
        });

        // 将 map 对象的值转换成数组返回（按首次出现的顺序）
        return Object.values(moduleMap);
    }

    const cancel = () => {
        setOpen(false);
        setIsEditTitle(false);
    }

    useEffect(() => {
        setOpen(props.open);
        setToolName(props.node?.data?.input?.toolName);
        setDescription(props.node?.data?.input?.description);
        setParameters(props.node?.data?.input?.parameters);
    }, [props]);

    // 初始化应用信息
    useEffect(() => {
        const getMcpTools = () => {
            $.ajax({
                url: `${CNF.xmcpApi}tools`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setMCPToolList(data.dat);
                        } else {
                            setMCPToolList([]);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function () {
                    messageApi.error('MCP服务异常', CNF.messageDuration);
                })
        }
        getMcpTools();
    }, []);

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            {contextHolder}
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {
                            isEditTitle ? <Input
                                value={currentTitle}
                                onChange={(e) => {
                                    setCurrentTitle(e.target.value);
                                }}
                            /> : props.node.data?.title
                        }
                        {
                            isEditTitle ?
                                <Button color='primary' variant='link' icon={<CheckOutlined />} onClick={() => {
                                    props.node.setData({
                                        ...props.node.data,
                                        title: currentTitle,
                                    });
                                    setIsEditTitle(false);
                                }} />
                                :
                                <Button color='primary' variant='link' icon={<EditOutlined />} onClick={() => {
                                    setIsEditTitle(true);
                                }} />
                        }
                    </Space>
                }
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>可用工具</p>
                <Select
                    placeholder='请选择工具'
                    style={{ width: '100%' }}
                    options={transformToGroupOptions(mcpToolList)}
                    value={toolName ? toolName : undefined}
                    onChange={(value) => {
                        // MCP工具
                        setToolName(value);
                        setDescription(mcpToolList.find(item => item.name === value)?.description);
                        setParameters(mcpToolList.find(item => item.name === value)?.parameters);
                        props.node.setData({
                            ...(delete props.node.data?.mcpTool, props.node.data),
                            input: {
                                toolName: value,
                                parameters: mcpToolList.find(item => item.name === value)?.parameters,
                            },
                        });
                        // 清空当前参数
                        setCurrentParameterKey('');
                    }}
                />
                {
                    description ? <Text style={{ fontSize: CNF.fontSizeSM }}>
                        <p style={{ fontWeight: 'bold', margin: 0, marginTop: 10, }}>工具描述：</p>
                        <p style={{ margin: 0, marginTop: 5, }}>{description.split('\n')[1]}</p>
                    </Text> : ''
                }
                {
                    parameters ? <Text style={{ fontSize: CNF.fontSizeSM }}>
                        <p style={{ fontWeight: 'bold', margin: 0, marginTop: 10, }}>参数说明：</p>
                        <Row style={{ margin: 0, marginTop: 5 }}>
                            <Col span={8} style={{ fontSize: CNF.fontSizeSM }}>变量名</Col>
                            <Col span={5} style={{ fontSize: CNF.fontSizeSM }}>变量类型</Col>
                            <Col span={11} style={{ fontSize: CNF.fontSizeSM }}>值</Col>
                        </Row>
                        {
                            Object.keys(parameters).map((key, index) => {
                                return <Row key={index} style={{ margin: 0, marginTop: 5, }}>
                                    <Col span={8} style={{ fontSize: CNF.fontSizeSM, paddingRight: 5 }}>
                                        <Popover content={parameters[key].description.split('，')[0]} title={key}>
                                            <Input size='small' disabled={true} value={key} />
                                        </Popover>
                                    </Col>
                                    <Col span={5} style={{ fontSize: CNF.fontSizeSM, paddingRight: 5 }}><Input size='small' disabled={true} value={parameters[key].type} /></Col>
                                    <Col span={11} style={{ fontSize: CNF.fontSizeSM }}>
                                        {
                                            parameters[key].type === "string" ?
                                                parameters[key].default?.indexOf('/') > -1 ? <div style={{ border: `1px solid #d9d9d9`, borderRadius: '4px', padding: '1px 4px', }}>
                                                    <Tag
                                                        key={key}
                                                        style={{ margin: 0, height: '19px', lineHeight: '19px', fontSize: 10 }}
                                                        closable
                                                        onClose={e => {
                                                            e.preventDefault();
                                                            setParameters({
                                                                parameters: {
                                                                    ...parameters,
                                                                    [key]: {
                                                                        ...parameters[key],
                                                                        default: '',
                                                                    }
                                                                }
                                                            });
                                                            props.node.setData({
                                                                ...props.node.data,
                                                                input: {
                                                                    parameters: {
                                                                        ...parameters,
                                                                        [key]: {
                                                                            ...parameters[key],
                                                                            default: '',
                                                                        }
                                                                    }
                                                                },
                                                            });
                                                        }}
                                                    >
                                                        {/* 根据变量路径的第一个数字确定变量来自的节点” */}
                                                        <span>{props.graph.getNodes().find(node => node.getZIndex().toString() === parameters[key].default.split('/')[0]).data.title}</span>/<span style={{ color: global.THEMECOLOR }}>{parameters[key].default.split('/').at(-1)}</span>
                                                    </Tag>
                                                </div> :
                                                    <Input
                                                        size='small'
                                                        placeholder='输入"/"插入变量'
                                                        value={parameters[key].default}
                                                        onChange={(e) => {
                                                            if (e.target.value?.indexOf('/') > -1) {
                                                                // 该参数
                                                                setCurrentParameterKey(key);
                                                            } else {
                                                                setParameters({
                                                                    ...parameters,
                                                                    [key]: {
                                                                        ...parameters[key],
                                                                        default: e.target.value,
                                                                    }
                                                                });
                                                                props.node.setData({
                                                                    ...props.node.data,
                                                                    input: {
                                                                        parameters: {
                                                                            ...parameters,
                                                                            [key]: {
                                                                                ...parameters[key],
                                                                                default: e.target.value,
                                                                            }
                                                                        }
                                                                    },
                                                                });
                                                                setCurrentParameterKey('');
                                                            }
                                                        }} />
                                                :
                                                <InputNumber size='small' style={{ width: '100%' }} value={parameters[key].default} onChange={(value) => {
                                                    setParameters({
                                                        ...parameters,
                                                        [key]: {
                                                            ...parameters[key],
                                                            default: e.target.value,
                                                        }
                                                    })
                                                    props.node.setData({
                                                        ...props.node.data,
                                                        input: {
                                                            parameters: {
                                                                ...parameters,
                                                                [key]: {
                                                                    ...parameters[key],
                                                                    default: e.target.value,
                                                                }
                                                            }
                                                        },
                                                    });
                                                }} />
                                        }
                                        {
                                            currentParameterKey === key ? <div style={{
                                                position: 'absolute',
                                                top: 28,
                                                left: 0,
                                                width: 180,
                                                padding: '6px 8px',
                                                boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1)',
                                                border: '1px solid #00000033',
                                                borderRadius: 6,
                                                background: '#fff',
                                                fontSize: CNF.fontSizeSM,
                                                zIndex: 9999,
                                            }}>
                                                <Space orientation='vertical' style={{ display: 'flex' }}>
                                                    {
                                                        props.graph && props.graph.getNodes().map(node => {
                                                            if (node.data?.key === 'End' || node.getZIndex() >= props.node.getZIndex()) return;
                                                            return <Popover key={node.id}
                                                                placement='leftTop'
                                                                arrow={false}
                                                                title={null}
                                                                align={{
                                                                    offset: [-12, 0],
                                                                }}
                                                                styles={{
                                                                    container: {
                                                                        padding: '4px 6px',
                                                                    },
                                                                }}
                                                                content={<Space orientation='vertical' style={{ display: 'flex' }}>
                                                                    {
                                                                        Object.keys(node.data?.key === 'Start' ? node.data?.input.sys : node.data?.output).map((item, index) => {

                                                                            return <Button key={index} color='default' variant='text' style={{ width: '100%', justifyContent: 'left' }} onClick={() => {
                                                                                const path = node.getZIndex().toString() + (node.data?.key === 'Start' ? '/input/sys/' : '/output/') + item;
                                                                                setParameters({
                                                                                    ...parameters,
                                                                                    [key]: {
                                                                                        ...parameters[key],
                                                                                        default: path,
                                                                                    }
                                                                                });
                                                                                props.node.setData({
                                                                                    ...props.node.data,
                                                                                    input: {
                                                                                        parameters: {
                                                                                            ...parameters,
                                                                                            [key]: {
                                                                                                ...parameters[key],
                                                                                                default: path,
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                });
                                                                                setCurrentParameterKey('');
                                                                            }}><Space><Text>{item}</Text><Tag>string</Tag></Space></Button>
                                                                        })
                                                                    }
                                                                </Space>}
                                                            >
                                                                <Flex>
                                                                    <Space style={{ width: '90%' }}>
                                                                        <Avatar size={20} shape='square' icon={node.data.icon} style={{ background: node.data.theme, }} />
                                                                        <span>{node.data.title}</span>
                                                                    </Space>
                                                                    <Space style={{ width: '10%', display: 'flex', justifyContent: 'flex-end' }}>
                                                                        <RightOutlined />
                                                                    </Space>
                                                                </Flex>
                                                            </Popover>
                                                        })
                                                    }
                                                </Space>
                                            </div> : ''
                                        }
                                    </Col>
                                </Row>
                            })
                        }
                    </Text> : ''
                }
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>输出变量</p>
                <div>
                    {
                        props.node?.data?.output && Object.keys(props.node?.data.output).map(key => {
                            return <Space key={key}><span>{key}</span><span style={{ color: CNF.basePlaceholderColor }}>string</span></Space>
                        })
                    }
                </div>
            </Modal>
        </ConfigProvider >
    );
}

export default MCPNodeEntity;